import { Box, Typography } from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import Text from "./Text";

export const TermsAndConditionsContainer = ({ textId, onEndScroll }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50;
      if (isAtBottom && onEndScroll) {
        onEndScroll(true);
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box pt={1} className={"fade-bottom"}>
      <Box
        ref={containerRef}
        overflow="scroll"
        className="appear-anim"
        style={{
          paddingBottom: "1px",
          transition: "none",
          maxHeight: "35vh",
        }}
      >
        <Box
          textAlign="justify"
          style={{
            lineHeight: 0.5,
            paddingBottom: "20px",
          }}
        >
          <Typography
            component={"div"}
            variant="caption"
            style={{ fontSize: 11 }}
          >
            <Text tId={textId} />
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
